module.exports = __webpack_public_path__ + "static/media/cacao1.954f5e57.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pioricost-fruit/cacao/cacao1.jpeg
// module id = 46
// module chunks = 0